import * as React from 'react';
import styles from './index.less';
import FLoadingTip from '@/components/FLoadingTip';
import { connect } from 'dva';
import { Dispatch } from 'umi';
import { ActivityDetailsPageModelState, ConnectState } from '@/models/connect';
import ResourceCompetition from '@/pages/activity/$id/ResourceCompetition';
import PlayNewer from './PlayNewer';
import InviteFriend from './InviteFriend';
import Questionnaire from './Questionnaire';
import * as AHooks from 'ahooks';
import { OnMountPageAction, OnUnmountPageAction } from '@/models/activityDetailsPage';
import { withRouter, useMatch, history } from 'umi';
import FResultTip from '@/components/FResultTip';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import { Helmet } from 'react-helmet';
import ExperienceOfficer from './ExperienceOfficer';
import SpringFestival from './SpringFestival';
import EditorPick from './EditorPick';
import Contest202409 from './Contest202409';
import SpringFestival2025 from './SpringFestival2025';
import Widget from './Widget';
import MoonFestival2025 from './MoonFestival2025';
import SpringFestival2026 from './SpringFestival2026';
// import { QRCode } from 'antd';
// import img_weixin from './weixin.jpg';

declare const wx: any;
interface ActivityProps {
  dispatch: Dispatch;
  activityDetailsPage: ActivityDetailsPageModelState;
}

function Activity({ dispatch, activityDetailsPage }: ActivityProps) {
  const match = useMatch('/activity/:id');
  const Activities = React.useRef<any>({
    ResourceCompetition: <ResourceCompetition />,
    'play-newer': <PlayNewer />,
    'invite-friend': <InviteFriend />,
    Questionnaire: <Questionnaire />,
    ExperienceOfficer: <ExperienceOfficer />,
    SpringFestival: <SpringFestival />,
    event_editorpick: <EditorPick />,
    event_contest202409: <Contest202409 />,
    SpringFestival2025: <SpringFestival2025 />,
    Widget: <Widget />,
    MoonFestival2025: <MoonFestival2025 />,
    SpringFestival2026: <SpringFestival2026 />,
  });

  AHooks.useMount(() => {
    dispatch<OnMountPageAction>({
      type: 'activityDetailsPage/onMountPage',
      payload: {
        activityID: (match?.params as { id: string }).id || '',
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountPageAction>({
      type: 'activityDetailsPage/onUnmountPage',
    });
  });

  if (activityDetailsPage.pageState === 'loading') {
    return <FLoadingTip height={window.innerHeight - 170} />;
  }

  if (activityDetailsPage.pageState === 'noDate') {
    return (
      <div
        style={{
          height: window.innerHeight - 170,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <FResultTip
          h1={
            // 活动不存在或者已暂停
            FI18n.i18nNext.tAuto('msg_event_suspend')
          }
          btnText={'返回首页'}
          onClickBtn={() => {
            history.push(FUtil.LinkTo.home());
          }}
        />
      </div>
    );
  }
  return (
    <>
      <Helmet>
        <title>{`${activityDetailsPage.pageTitle} - Freelog`}</title>
      </Helmet>
      {Activities.current[activityDetailsPage.showActivity] ? (
        <>{Activities.current[activityDetailsPage.showActivity]}</>
      ) : (
        <div
          style={{
            height: window.innerHeight - 170,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <FResultTip
            h1={'活动不存在或者已暂停'}
            btnText={'返回首页'}
            onClickBtn={() => {
              history.push(FUtil.LinkTo.home());
            }}
          />
        </div>
      )}
    </>
  );
}

export default withRouter(
  connect(({ activityDetailsPage }: ConnectState) => ({
    activityDetailsPage,
  }))(Activity),
);
